export default __webpack_public_path__ + "a37b53789723d050758a747b5f9e490e.svg";